import PageWrapper from "../../../../components/common/layout/PageWrapper";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { VIEW_TYPES } from "../../../../../config/view/types";
import useViewDataObject from "../../../../../hooks/redux/useViewDataObject";
import { getContentManagementDataById } from "../../../../../axios/api/services";
import { CONTENT_MANAGEMENT_ID } from "@duosoftbg/nacid-components";
import ViewPageWrapper from "../../../contacts/ViewPageWrapper";
import LawForm from "./LawForm";

const LawManagement = () => {
  const { t } = useTranslation();
  const viewType = VIEW_TYPES.LAW_EDIT;
  const { object, data: law } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.LAW), []);

  return (
    <PageWrapper title={t("t.page.law.edit")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {law && <LawForm law={law}></LawForm>}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default LawManagement;
